__turbopack_context__.v({
  "root": "VitaminAngelsBanner-module__hom8iW__root",
  "vaLink": "VitaminAngelsBanner-module__hom8iW__vaLink",
  "vaLinkArrow": "VitaminAngelsBanner-module__hom8iW__vaLinkArrow",
  "vaLogo": "VitaminAngelsBanner-module__hom8iW__vaLogo",
});
